// 99SVG theme JS — cart drawer, AJAX add, mobile nav
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // ---- Cart drawer ----
  const drawer = $('#CartDrawer');
  function openDrawer() { drawer && drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer && drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });

  async function refreshCart() {
    try {
      const res = await fetch(window.routes.cart_url + '.js');
      const cart = await res.json();
      renderCart(cart);
      $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    } catch (e) { console.error(e); }
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ---- Cart upsell: the Everything Bundle ----
  var UPSELL_HANDLE = (window.upsellHandle || 'the-ultimate-collection');
  var _bundle = null;
  async function ensureBundle() {
    if (_bundle !== null) return _bundle;
    try { _bundle = await (await fetch('/products/' + UPSELL_HANDLE + '.js')).json(); }
    catch (e) { _bundle = false; }
    return _bundle;
  }
  async function renderUpsell(cart) {
    var el = $('#CartUpsell');
    if (!el) return;
    var has = cart.items.some(function (i) { return i.handle === UPSELL_HANDLE; });
    if (!cart.items.length || has) { el.hidden = true; el.innerHTML = ''; return; }
    var b = await ensureBundle();
    if (!b) { el.hidden = true; return; }
    var img = b.featured_image ? b.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1') : '';
    var save = b.compare_at_price && b.compare_at_price > b.price
      ? Math.round((b.compare_at_price - b.price) / b.compare_at_price * 100) : 0;
    el.hidden = false;
    el.innerHTML =
      '<div class="upsell">' +
        '<div class="upsell__tag">⭐ Best value — add &amp; save</div>' +
        '<div class="upsell__row">' +
          (img ? '<img class="upsell__img" src="' + img + '" alt="">' : '') +
          '<div class="upsell__info">' +
            '<div class="upsell__title">' + b.title + '</div>' +
            '<div class="upsell__price">' + money(b.price) +
              (save ? ' <span class="upsell__save">' + save + '% OFF</span>' : '') + '</div>' +
          '</div>' +
          '<button class="btn btn--primary btn--sm" data-upsell="' + b.variants[0].id + '">Add</button>' +
        '</div>' +
      '</div>';
  }

  function renderCart(cart) {
    const items = $('#CartItems');
    const foot = $('#CartFoot');
    if (!items) return;
    if (!cart.items.length) {
      items.innerHTML = '<p style="padding:30px 0;text-align:center;color:var(--color-muted)">Your cart is empty</p>';
      if (foot) foot.hidden = true;
      renderUpsell(cart);
      return;
    }
    if (foot) foot.hidden = false;
    renderUpsell(cart);
    items.innerHTML = cart.items.map(it => `
      <div class="line">
        <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1') : ''}" alt="">
        <div style="flex:1">
          <div style="font-weight:600;font-size:.92rem">${it.product_title}</div>
          <div style="color:var(--color-muted);font-size:.85rem">${money(it.final_price)}</div>
          <button class="btn btn--sm btn--ghost" data-remove="${it.key}" style="margin-top:6px;padding:5px 12px">Remove</button>
        </div>
      </div>`).join('');
    const sub = $('#CartSubtotal');
    if (sub) sub.textContent = money(cart.total_price);
  }

  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-remove]');
    if (rm) {
      e.preventDefault();
      await fetch(window.routes.cart_change_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: rm.dataset.remove, quantity: 0 })
      });
      refreshCart();
    }
    const up = e.target.closest('[data-upsell]');
    if (up) {
      e.preventDefault();
      up.disabled = true; up.textContent = 'Adding…';
      await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(up.dataset.upsell, 10), quantity: 1 })
      });
      await refreshCart();
      showToast();
    }
  });

  // ---- toast ----
  function showToast() {
    const t = $('#CartToast');
    if (!t) return;
    t.classList.add('show');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(() => t.classList.remove('show'), 3200);
  }

  // ---- AJAX add to cart (delegated, works for dynamically-styled forms) ----
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      await fetch(window.routes.cart_add_url + '.js', { method: 'POST', body: new FormData(form) });
      await refreshCart();
      showToast();
      const big = form.closest('.main-product') || form.closest('[data-open-drawer]');
      if (big) openDrawer();
    } catch (err) { console.error(err); }
    if (btn) { btn.disabled = false; btn.textContent = label; }
  });

  // ---- wishlist toggle ----
  document.addEventListener('click', (e) => {
    const w = e.target.closest('[data-wish]');
    if (w) { e.preventDefault(); w.textContent = w.textContent.trim() === '♡' ? '♥' : '♡'; }
  });

  // ---- exit-intent / delayed popup ----
  const popup = $('#ExitPopup');
  if (popup) {
    let shown = sessionStorage.getItem('popup99') === '1';
    const open = () => { if (shown) return; popup.classList.add('is-open'); shown = true; sessionStorage.setItem('popup99', '1'); };
    const close = () => popup.classList.remove('is-open');
    setTimeout(open, 15000);
    document.addEventListener('mouseout', (e) => { if (e.clientY <= 0) open(); });
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-popup-close]') || e.target === popup) close();
    });
  }

  // ---- sticky add-to-cart (product pages) ----
  const sticky = $('#StickyCart');
  if (sticky) {
    window.addEventListener('scroll', () => {
      sticky.classList.toggle('show', window.scrollY > 700);
    }, { passive: true });
  }

  // ---- product recommendations (frequently bought together) ----
  const recs = $('#ProductRecs');
  if (recs) {
    const pid = recs.dataset.productId;
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=4&intent=related')
      .then(r => r.json())
      .then(d => {
        const ps = (d.products || []).slice(0, 4);
        if (!ps.length) return;
        const grid = $('#ProductRecsGrid');
        grid.innerHTML = ps.map(p => {
          let img = p.featured_image || (p.images && p.images[0]) || '';
          if (img && typeof img === 'object') img = img.src;
          img = img ? img.replace(/(\.[a-z]+)(\?.*)?$/i, '_400x$1') : '';
          return '<a href="' + p.url + '" class="card pcard">' +
            '<div class="pcard__media">' + (img ? '<img src="' + img + '" loading="lazy" alt="">' : '') + '</div>' +
            '<div class="pcard__body"><h3 class="pcard__title">' + p.title + '</h3>' +
            '<div class="price"><span class="price__now" style="font-size:.9rem">View →</span></div></div></a>';
        }).join('');
        recs.hidden = false;
      })
      .catch(() => {});
  }

  // ---- Mobile nav ----
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-nav-toggle]')) {
      e.preventDefault();
      const nav = $('.header__nav');
      if (nav) nav.classList.toggle('is-open');
    } else if (!e.target.closest('.header__nav') && !e.target.closest('[data-nav-toggle]')) {
      const nav = $('.header__nav');
      if (nav) nav.classList.remove('is-open');
    }
  });

  refreshCart();
})();
